import algoliasearch from 'algoliasearch/lite'

import { config } from '@/config'

const prefixes = {
  development: 'dev_',
  staging: 'stg_',
  production: 'prod_',
}

export const indexes = {
  organizationArtists:
    prefixes[config.environment] +
    'organization_artists_replica_followerCount_desc',
  items: prefixes[config.environment] + 'items',
  itemsPriceAsc: prefixes[config.environment] + 'items_replica_price_asc',
  itemsPriceDesc: prefixes[config.environment] + 'items_replica_price_desc',
}

export const filters = {
  organizationId: `organizationId:${config.organizationId}`,
  /**
   * @description
   * トップ表示アーティスト用フィルター
   * 指定したアーティストIDのみ表示、指定がない場合は全表示
   */
  topDisplayArtists: (topDisplayArtistIds?: string[] | null) => {
    if (!topDisplayArtistIds?.length)
      return `organizationId:${config.organizationId}`

    return (
      `organizationId:${config.organizationId} AND ` +
      `${topDisplayArtistIds.map(id => `objectID:${id}`).join(' OR ')}`
    )
  },
  itemStoreArtist(
    artistId: string,
    publishedAtTimestamp: number,
    // 除外するアイテムID、アイテム詳細で当該アイテムは一覧から除外する
    itemId?: string,
    // 作品一覧のキーワード検索を行っているかどうか
    hasKeyword?: boolean
  ) {
    if (!artistId) return

    // 検索フィルター
    const filters = [
      `issuedByArtistId:${artistId}`,
      'isPublished:true',
      'salesStatus:active',
      'review.status:accepted',
      `publishedAtTimestamp <= ${publishedAtTimestamp}`,
      itemId ? `NOT objectID:${itemId}` : '',
    ]

    // キーワード検索を行っていない場合、ストアコレクション内のアイテムは除外する
    if (!hasKeyword) {
      filters.push('NOT isCollectionSales:true')
    }

    return filters.filter(o => !!o).join(' AND ')
  },
}

export function client() {
  return algoliasearch('VA2ZJ3N9DB', '6a135579de7a9a4898d51f876722411c')
}
